/**
 * Success toast for a completed Signify workflow run. Consumers: `ArWorkflowMenu`
 * and `ArTableControls`.
 *
 * `orderStatus: 'EXISTING'` is Signify reporting that it already holds an order
 * under this `externalReference` and returned that one, creating nothing. Say
 * exactly that: reporting it as a fresh order would tell a PM a factory order was
 * placed today that was placed earlier, and claiming *this selection* placed the
 * returned order overstates what the answer proves (SYD-2325).
 */
const formatSignifySuccessMessage = (
  apiResult: Record<string, unknown> | undefined,
  workflowLabel: string | undefined,
): string => {
  if (!apiResult) return `${workflowLabel ?? 'Workflow'} completed.`;
  if (apiResult.quoteId) {
    const quoteLabel = apiResult.quoteNumber ? `Quote ${apiResult.quoteNumber}` : `Quote ${apiResult.quoteId}`;
    const rev = apiResult.revision != null ? ` (rev ${apiResult.revision})` : '';
    const count = apiResult.productsCount ? ` submitted with ${apiResult.productsCount} products` : ' submitted';
    return `${quoteLabel}${rev}${count}.`;
  }
  if (apiResult.salesdocument) {
    const msg = apiResult.message ? ` ${apiResult.message}` : '';
    if (apiResult.orderStatus === 'EXISTING') {
      return `Signify already held order ${apiResult.salesdocument} for this reference and returned it — nothing new was submitted.${msg}`;
    }
    return `Order ${apiResult.salesdocument} created.${msg}`;
  }
  if (apiResult.message) return String(apiResult.message);
  return `${workflowLabel ?? 'Workflow'} completed.`;
};

export default formatSignifySuccessMessage;
